import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { client, ErrorType } from '@chegg/pricing-sdk';
import { useCallback, useEffect, useState } from 'react';
import { captureAuthorizeErrors } from '../utils/captureAuthorizeErrors';
var PRICING_SDK_AUTHORIZATION_ERROR = 'Error in Pricing Sdk Authorization';
var usePricingSdkAuthorize = function usePricingSdkAuthorize(_ref) {
  var _ref$skip = _ref.skip,
    skip = _ref$skip === void 0 ? false : _ref$skip,
    authorizePayload = _ref.authorizePayload,
    location = _ref.location;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = useState({
      data: null,
      errors: null,
      success: undefined
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    authResp = _useState4[0],
    setAuthResp = _useState4[1];
  var authorize = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var resp, _resp$errors$, errorMessage, message;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setLoading(true);
            _context.prev = 1;
            _context.next = 4;
            return client.authorize(_objectSpread({}, authorizePayload));
          case 4:
            resp = _context.sent;
            setAuthResp(resp);
            if (resp.errors) {
              errorMessage = (_resp$errors$ = resp.errors[0]) === null || _resp$errors$ === void 0 ? void 0 : _resp$errors$.message;
              captureAuthorizeErrors({
                location: location,
                errorMessage: errorMessage
              });
            }
            setLoading(false);
            _context.next = 17;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](1);
            message = PRICING_SDK_AUTHORIZATION_ERROR;
            if (_context.t0 instanceof Error) {
              message = _context.t0.message;
            }
            setAuthResp({
              data: null,
              errors: [{
                code: 'unknown',
                message: message,
                type: ErrorType.SERVER
              }],
              success: false
            });
            captureAuthorizeErrors({
              location: location,
              errorMessage: message
            });
            setLoading(false);
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 10]]);
    }));
    return function authorize() {
      return _ref2.apply(this, arguments);
    };
  }();
  var refetch = useCallback(function () {
    return authorize();
  }, [authorizePayload, location]);
  useEffect(function () {
    if (!skip && !loading) {
      authorize();
    }
  }, [skip]);
  if (skip) {
    return {
      status: 'skipped'
    };
  }
  if (loading) {
    return {
      status: 'loading'
    };
  }
  if (authResp.success === true) {
    return {
      status: 'ok',
      data: _objectSpread({}, authResp),
      refetch: refetch
    };
  }
  if (authResp.errors) {
    return {
      status: 'error',
      metadata: authResp.errors,
      refetch: refetch
    };
  }

  // default to loading status to avoid returning undefined
  return {
    status: 'loading'
  };
};
export default usePricingSdkAuthorize;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/hooks/usePricingSdkAuthorize.js
// module id = 4117
// module chunks = 11